import React from 'react';
import './ToS.css';
import { useTranslation } from '../i18n';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="long-text-wrapper">
      <h3>Bookie - {t.privacypolicy}</h3>
      <h4>{t.effectiveDate}: 27 Nov, 2024</h4>
      <div className="pt-65">{t.pp.intro}</div>

      <h4>1. {t.pp.informationHeader}</h4>
      <div className="pt-65">{t.pp.informationMessage}</div>
      <ul>
        <li className="pt-65">{t.pp.informationList1}</li>
        <li className="pt-65">{t.pp.informationList2}</li>
      </ul>

      <h4>2. {t.pp.usageHeader}</h4>
      <div className="pt-65">{t.pp.usageMessage}</div>

      <ul>
        <li className="pt-65">{t.pp.usageList1}</li>
        <li className="pt-65">{t.pp.usageList2}</li>
        <li className="pt-65">{t.pp.usageList3}</li>
      </ul>

      <div>{t.pp.usageExemptHeader}</div>
      <ul>
        <li className="pt-65">{t.pp.usageExemptList1}</li>
        <li className="pt-65">{t.pp.usageExemptList2}</li>
      </ul>

      <h4>3. {t.pp.storageHeader}</h4>
      <div className="pt-65">{t.pp.storageMessage}</div>

      <h4>4. {t.pp.userControlHeader}</h4>
      <div className="pt-65">{t.pp.userControlMessage}</div>

      <ul>
        <li className="pt-65">{t.pp.userControlList1}</li>
        <li className="pt-65">{t.pp.userControlList2}</li>
      </ul>

      <h4>5. {t.pp.dataRetentionHeader}</h4>
      <div className="pt-65">{t.pp.dataRetentionMessage}</div>

      <h4>6. {t.pp.partiesHeader}</h4>
      <div className="pt-65">{t.pp.partiesMessage}</div>

      <h4>7. {t.pp.changesHeader}</h4>
      <div className="pt-65">{t.pp.changesMessage}</div>
    </div>
  );
};

export default PrivacyPolicy;
